import React from 'react';
import "./prostyle.scss";
import ProCarousel from "./ProCarousel";

import hero01 from "../imgs33/hero-01.png";
import hero02 from "../imgs33/hero-02.png";
import hero03 from "../imgs33/hero-03.png";
import hero04 from "../imgs33/hero-04.png";
import hero05 from "../imgs33/hero-05.png";
import hero06 from "../imgs33/hero-06.png";
import hero07 from "../imgs33/hero-07.png";
import hero08 from "../imgs33/hero-08.png";

const GALLERY = [
    {
        image: hero01,
        alt: '33 inch Square Textura Pro digital canvas in a walnut frame',
        imageFit: 'contain',
        backgroundColor: '#f0f0f0'
    },
    {image: hero02, alt: '33 inch Square Textura Pro in a reception space'},
    {image: hero03, alt: '33 inch Square Textura Pro in a meeting room'},
    {image: hero04, alt: '33 inch Square Textura Pro in a lounge'},
    {image: hero05, alt: '33 inch Square Textura Pro in a hospitality interior'},
    {image: hero06, alt: '33 inch Square Textura Pro in a commercial interior'},
    {
        image: hero07,
        alt: '33 inch Square Textura Pro connectivity detail',
        imageFit: 'contain',
        backgroundColor: '#f0f0f0'
    },
    {
        image: hero08,
        alt: '33 inch Square Textura Pro rear profile',
        imageFit: 'contain',
        backgroundColor: '#f0f0f0'
    }
];

const ProVerticalCarousel33 = () => (
    <div style={{
        textAlign: 'center',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '60px'
    }}>
        <ProCarousel
            data={GALLERY}
            time={3000}
            width="45vw"
            height="60vh"
            radius="10px"
            slideNumber={false}
            captionPosition="bottom"
            automatic={false}
            dots={false}
            pauseIconColor="white"
            pauseIconSize="40px"
            slideBackgroundColor="#f0f0f0"
            slideImageFit="cover"
            mediaBackgroundColor="#f0f0f0"
            thumbnails={true}
            thumbnailWidth="100px"
            thumbnailHeight="100px"
            style={{
                textAlign: 'center',
                maxWidth: '100vw',
                backgroundColor: '#f4f4f4'
            }}
        />
    </div>
);

export default ProVerticalCarousel33;
